import { render, staticRenderFns } from "./recepcao_medico.vue?vue&type=template&id=b789e07a&scoped=true"
import script from "./recepcao_medico.vue?vue&type=script&lang=js"
export * from "./recepcao_medico.vue?vue&type=script&lang=js"
import style0 from "./recepcao_medico.vue?vue&type=style&index=0&id=b789e07a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b789e07a",
  null
  
)

export default component.exports